<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <v-container>
      <ik-data-table
        ref="table"
        :model="model"
        :need-loading="needLoading"
        entity-name="AwardType"
        icon="mdi-cash-usd"
        @add-new="addNew"
      >
        <template #item.imageDisplay="{item}">
          <div style="display: flex;">
            <img
              v-if="item.image"
              :src="item.image"
              alt="Image"
              style="width: 25px; height: 25px; margin-right: 5px;"
            >
          </div>
        </template>
      </ik-data-table>
    </v-container>
    <ik-entity-form
      v-model="showVoucherTypeDialog"
      :edited-index="-1"
      :model="voucherModel"
      @need-refresh="loadVoucherTypes"
    />
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import AwardType from '@/model/dataLayer/api/Vip/AwardType'
import IkEntityForm from '@/plugins/EntityFrameWork/IkEntityForm.vue'
import VoucherTypes from '@/model/dataLayer/api/Vip/VoucherTypes'

export default {
  components: {
    IkEntityForm,
    IkDataTable
  },
  data: function () {
    return ({
      needLoading: false,
      showVoucherTypeDialog: false,
      editItem: null,
      model: AwardType,
      voucherModel: VoucherTypes
    })
  },
  methods: {
    async loadVoucherTypes () {
      this.needLoading = true
      await this.voucherModel.getList(true)
      this.needLoading = false
    },
    addNew (info) {
      if (info.text === 'awardVoucherTypeId') {
        this.showVoucherTypeDialog = true
      }
    }
  }
}
</script>
